import { getRawCardNumber } from '@utils';

import { buyActions, cardsActions, globalActions } from '@modules';
import { TMiddleware } from '@modules/types';

import { checkActionsType } from './utils';

export const runZHFlow: TMiddleware = store => next => action => {
  if (checkActionsType(action, [globalActions.runZHFlow])) {
    const { global, cards } = store.getState();
    const { zhModalType } = global;
    const { card } = cards;
    const { cvv, number, holderName, expDate } = card;
    if (zhModalType === 'buy') {
      const cardData = action.payload;
      store.dispatch(buyActions.buyRequest({ zh_agree: true, ...cardData }));
    }
    if (zhModalType === 'bind') {
      const [cardMM, cardYY] = expDate.split('/');
      const bindCardParams = {
        number: getRawCardNumber(number),
        cvv,
        holder_name: holderName,
        expiration_year: `20${cardYY}`,
        expiration_month: cardMM,
        zh_agree: true,
      };
      store.dispatch(cardsActions.bind({ ...bindCardParams }));
    }
  }
  return next(action);
};

export default runZHFlow;
